function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.556 8.969L8.17 13.356A.51.51 0 008 13.75v1.688c0 .337.225.562.563.562h1.687a.51.51 0 00.394-.169l4.387-4.387-2.475-2.475zM16.831 8.856L15.144 7.17a.544.544 0 00-.788 0L13.344 8.18l2.475 2.475 1.012-1.012a.544.544 0 000-.788z",
  fill: "#9090A7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  stroke: "#E7E7ED"
});

function SvgEditButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgEditButton;